import Vue from 'vue';

/*
 * SKU 在庫状況ラベル
 */ //
export default Vue.extend({
  props: [
    'sku'
  ],
  computed: {
    isWarningLv4() {
      return (this.sku.stock_count != null) && (this.sku.stock_count <= 2);
    },
    isWarningLv3() {
      return (this.sku.stock_count != null) && (this.sku.stock_count > 2) && (this.sku.stock_count <= 4);
    },
    isWarningLv2() {
      return (this.sku.stock_count != null) && (this.sku.stock_count > 4) && (this.sku.stock_count <= 6);
    },
    isWarningLv1() {
      return (this.sku.stock_count != null) && (this.sku.stock_count > 6) && (this.sku.stock_count <= 10);
    }
  }
});
